/* ===========================================================================
   SALON homepage refinements (appended)
   1) open into the Enchanted Forest by default
   2) real backdrop thumbnails on the Rooms menu tiles
   3) vibrant, true-colour artwork on the walls (match the detail view)
   4) lighter always-on text (SKU + edition line live in the click-through detail)
   =========================================================================== */
(function(){
"use strict";

/* ---- (1) default landing room -> forest for first-time visitors ---- */
try{
  if(!localStorage.getItem('salon3d_v2') && window.Shop && window.Shop.state){
    window.Shop.state.room='forest';
    if(typeof window.Shop.save==='function') window.Shop.save();
  }
}catch(e){}

/* ---- (4) declutter the always-visible commerce bar (detail still on click) ---- */
try{
  var st=document.createElement('style');
  st.textContent='.combar .eyebrow .sku{display:none!important}.combar .edtxt{display:none!important}';
  document.head.appendChild(st);
}catch(e){}

/* ---- (2) backdrop thumbnails for each Rooms-menu tile ---- */
var _thumbs={};
function paintThumbs(){
  var grid=document.querySelector('.roomgrid'); if(!grid) return;
  var cards=grid.querySelectorAll('.roomcard[data-room]');
  for(var i=0;i<cards.length;i++){
    var card=cards[i], id=card.getAttribute('data-room');
    var mini=card.querySelector('.mini'); if(!mini || mini.getAttribute('data-thumbed')) continue;
    var url=_thumbs[id];
    if(url===undefined){
      url='';
      try{
        var r=(window.ROOM3D||{})[id];
        if(r && window.Backdrops && typeof window.Backdrops.paint==='function'){
          var cv=window.Backdrops.paint(id,r);
          if(cv && cv.toDataURL) url=cv.toDataURL('image/jpeg',0.7);
        }
      }catch(e){}
      _thumbs[id]=url;
    }
    if(url){
      mini.style.backgroundImage='url('+url+')';
      mini.style.backgroundSize='cover';
      mini.style.backgroundPosition='center';
      mini.setAttribute('data-thumbed','1');
    }
  }
}
(function watchGrid(){
  var grid=document.querySelector('.roomgrid');
  if(!grid){ setTimeout(watchGrid,250); return; }
  try{ new MutationObserver(function(){ paintThumbs(); }).observe(grid,{childList:true}); }catch(e){}
  paintThumbs();
})();

/* ---- (3) keep wall artwork vibrant / true-colour, self-correcting ---- */
function ensureVibrant(){
  var GAL=window.GAL; if(!GAL || !GAL.artGroups) return;
  for(var i=0;i<GAL.artGroups.length;i++){
    var g=GAL.artGroups[i], mesh=g && g.userData && g.userData.artMesh;
    if(!mesh) continue;
    var m=mesh.material; if(!m || !m.map) continue;
    if(m.emissiveMap!==m.map || m.emissiveIntensity<0.5){
      m.emissiveMap=m.map;
      if(m.emissive && m.emissive.setRGB) m.emissive.setRGB(1,1,1);
      m.emissiveIntensity=0.82;
      m.needsUpdate=true;
    }
  }
}
setInterval(ensureVibrant,600);

})();
